module.exports = __webpack_public_path__ + "static/6bc3a5fc01d6afeae2aa4336adcccee2.png";